import React, { useState, useEffect } from 'react';
import API from '../../services/api';
import { THEME } from '../../constants/theme';
import ETOStatusUpdate from './ETOStatusUpdate';
import AddETOCaseModal from './AddETOCaseModal'; // 👈 Nayi modal file import ki

// Dashboard ("Add eto Income") ne 5 second ke andar flag set kiya ho to add form khulna chahiye
const openedFromDashboard = () => {
    try {
        const t = Number(sessionStorage.getItem('eto_open_add_case'));
        return !!t && Date.now() - t < 5000;
    } catch (e) {
        return false;
    }
};

const ETOCases = ({ initialAction }) => {
    const [cases, setCases] = useState([]);
    
    // 👇 Modal ka state jo dashboard se aane par true ho jayega
    const [showModal, setShowModal] = useState(initialAction === 'add_case' || openedFromDashboard());

    // Pagination & Search States
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRows, setTotalRows] = useState(0);

    // Navigation & Status Update View State
    const [currentView, setCurrentView] = useState('list');
    const [selectedCaseId, setSelectedCaseId] = useState(null);

    // Dashboard ("Add eto Income") se aane par add form direct khule.
    // Sidebar / ETO panel se aane par initialAction null hota hai, to normal cases list hi dikhegi.
    useEffect(() => {
        if (initialAction === 'add_case') setShowModal(true);
    }, [initialAction]);

    useEffect(() => {
        if (searchQuery.trim() === '') {
            fetchCases(currentPage, rowsPerPage);
        } else {
            handleSearch(searchQuery);
        }
    }, [currentPage, rowsPerPage]);

    // 1. Fetch Cases with Pagination API
    const fetchCases = async (page, limit) => {
        try {
            const res = await API.get(`/v1/eto/cases?page=${page}&limit=${limit}`);
            if (res.data.success) {
                const caseList = res.data.data || res.data.cases || [];
                setCases(caseList);
                setTotalPages(res.data.pagination?.totalPages || 1);
                setTotalRows(res.data.pagination?.total || caseList.length);
            }
        } catch (err) {
            console.error("Error fetching cases:", err);
        }
    };

    // 2. Fetch Cases using Separate Search API
    const handleSearch = async (query) => {
        try {
            if (!query.trim()) {
                fetchCases(1, rowsPerPage);
                return;
            }
            const res = await API.get(`/v1/eto/cases/search?query=${encodeURIComponent(query)}`);
            if (res.data.success) {
                const searchList = res.data.data || res.data.cases || [];
                setCases(searchList);
                setTotalPages(1);
                setTotalRows(searchList.length);
            }
        } catch (err) {
            console.error("Error searching cases:", err);
        }
    };

    const onSearchInputChange = (e) => {
        const val = e.target.value;
        setSearchQuery(val);
        setCurrentPage(1);
        if (val.trim() === '') {
            fetchCases(1, rowsPerPage);
        } else {
            handleSearch(val);
        }
    };

    if (currentView === 'status_update') {
        return <ETOStatusUpdate caseId={selectedCaseId} onBack={() => setCurrentView('list')} />;
    }

    const indexOfFirstRow = (currentPage - 1) * rowsPerPage;

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '15px' }}>
                <h3 style={{ margin: 0, color: '#1e293b' }}>ETO Cases List</h3>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
                    <input
                        type="text"
                        placeholder="Search by customer name, account..."
                        value={searchQuery}
                        onChange={onSearchInputChange}
                        style={{ padding: '10px 14px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '14px', outline: 'none', width: '280px', backgroundColor: '#fff' }}
                    />
                    <button
                        onClick={() => setShowModal(true)}
                        style={{ padding: '10px 20px', backgroundColor: THEME.secondary || '#2563eb', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', boxShadow: '0 4px 6px rgba(37, 99, 235, 0.2)' }}
                    >
                        + Add New Case
                    </button>
                </div>
            </div>

            {/* Cases Table */}
            <div style={{ backgroundColor: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f8fafc', borderBottom: '1px solid #e2e8f0', color: '#64748b', fontSize: '13px' }}>
                            <th style={{ padding: '15px' }}>Case No</th>
                            <th style={{ padding: '15px' }}>Customer (Account ID)</th>
                            <th style={{ padding: '15px' }}>Agent</th>
                            <th style={{ padding: '15px' }}>Income</th>
                            <th style={{ padding: '15px' }}>Type</th>
                            <th style={{ padding: '15px' }}>Account Title</th>
                            <th style={{ padding: '15px', textAlign: 'center' }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(cases) && cases.map((item) => (
                            <tr key={item.id} style={{ borderBottom: '1px solid #f1f5f9', fontSize: '14px', color: '#334155' }}>
                                <td style={{ padding: '15px', fontWeight: 'bold' }}>#{item.id}</td>
                                <td style={{ padding: '15px' }}>
                                    <div style={{ fontWeight: '600' }}>{item.customer_name}</div>
                                    <div style={{ fontSize: '12px', color: '#2563eb', fontWeight: '500' }}>Acc ID: #{item.customer_account_id || 'N/A'}</div>
                                </td>
                                <td style={{ padding: '15px' }}>{item.agent_name || 'N/A'}</td>
                                <td style={{ padding: '15px', color: '#10b981', fontWeight: 'bold' }}>Rs. {item.income}</td>
                                <td style={{ padding: '15px' }}>
                                    <span style={{ 
                                        padding: '4px 10px', borderRadius: '6px', 
                                        backgroundColor: item.voucher_type === 'CRV' ? '#dbeafe' : item.voucher_type === 'BRV' ? '#fef3c7' : '#e0e7ff', 
                                        color: item.voucher_type === 'CRV' ? '#1e40af' : item.voucher_type === 'BRV' ? '#92400e' : '#3730a3', 
                                        fontSize: '12px', fontWeight: 'bold' 
                                    }}>
                                        {item.voucher_type}
                                    </span>
                                </td>
                                <td style={{ padding: '15px' }}>{item.account_title || (item.voucher_type === 'JV' ? 'Customer Account' : '-')}</td>
                                <td style={{ padding: '15px', textAlign: 'center' }}>
                                    <button 
                                        onClick={() => {
                                            setSelectedCaseId(item.id);
                                            setCurrentView('status_update');
                                        }}
                                        style={{ padding: '6px 12px', backgroundColor: '#0284c7', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' }}
                                    >
                                        Change Status
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {(!cases || cases.length === 0) && (
                            <tr>
                                <td colSpan="7" style={{ textAlign: 'center', padding: '30px', color: '#94a3b8' }}>No ETO Cases Found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>

                {/* Professional Pagination Bar */}
                {totalRows > 0 && searchQuery.trim() === '' && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 20px', borderTop: '1px solid #e2e8f0', backgroundColor: '#f8fafc', flexWrap: 'wrap', gap: '10px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '13px', color: '#64748b' }}>
                            <span>Showing <b>{indexOfFirstRow + 1}</b> to <b>{Math.min(indexOfFirstRow + rowsPerPage, totalRows)}</b> of <b>{totalRows}</b> entries</span>
                            <select
                                value={rowsPerPage}
                                onChange={(e) => {
                                    setRowsPerPage(Number(e.target.value));
                                    setCurrentPage(1);
                                }}
                                style={{ padding: '6px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', backgroundColor: '#fff', fontSize: '13px', outline: 'none', cursor: 'pointer' }}
                            >
                                <option value={10}>10 rows</option>
                                <option value={20}>20 rows</option>
                                <option value={50}>50 rows</option>
                                <option value={100}>100 rows</option>
                            </select>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <button
                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                disabled={currentPage === 1}
                                style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', backgroundColor: currentPage === 1 ? '#f1f5f9' : '#fff', color: currentPage === 1 ? '#94a3b8' : '#334155', fontSize: '13px', fontWeight: '600', cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
                            >
                                Previous
                            </button>

                            <div style={{ display: 'flex', gap: '4px' }}>
                                {Array.from({ length: totalPages }, (_, i) => i + 1).map(number => {
                                    if (
                                        number === 1 || 
                                        number === totalPages || 
                                        (number >= currentPage - 1 && number <= currentPage + 1)
                                    ) {
                                        return (
                                            <button
                                                key={number}
                                                onClick={() => setCurrentPage(number)}
                                                style={{
                                                    padding: '6px 12px',
                                                    borderRadius: '6px',
                                                    border: currentPage === number ? '1px solid #2563eb' : '1px solid #cbd5e1',
                                                    backgroundColor: currentPage === number ? '#2563eb' : '#fff',
                                                    color: currentPage === number ? '#fff' : '#334155',
                                                    fontSize: '13px',
                                                    fontWeight: '600',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                {number}
                                            </button>
                                        );
                                    } else if (
                                        number === currentPage - 2 || 
                                        number === currentPage + 2
                                    ) {
                                        return <span key={number} style={{ padding: '6px 4px', color: '#94a3b8' }}>...</span>;
                                    }
                                    return null;
                                })}
                            </div>

                            <button
                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                disabled={currentPage === totalPages}
                                style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', backgroundColor: currentPage === totalPages ? '#f1f5f9' : '#fff', color: currentPage === totalPages ? '#94a3b8' : '#334155', fontSize: '13px', fontWeight: '600', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {/* Separate Modal Component Call */}
            <AddETOCaseModal 
                isOpen={showModal} 
                onClose={() => {
                    try { sessionStorage.removeItem('eto_open_add_case'); } catch (e) {}
                    setShowModal(false);
                }} 
                onSuccess={() => fetchCases(currentPage, rowsPerPage)} 
            />
        </div>
    );
};

export default ETOCases;